module.exports = __webpack_public_path__ + "img/DO.4e519a7a.png";